import React, {Component} from "react";
import {graphql} from "react-apollo";
import {connect} from "react-redux";
import gql from "graphql-tag";
import GraphQLErrors from "../../components/GraphQLErrors";
import AuthenticateStripePayment from "./AuthenticateStripePayment";
import { getStripePublishableKey } from "../../config";
import { StripeProvider, Elements } from 'react-stripe-elements';
import {requestShowOrderStatus} from "../../actions/CheckoutApiActions";

class AuthenticatePayment extends Component {

  render() {
    let {data} = this.props;
    if (data.loading) return null;
    if (data.error) return <GraphQLErrors error={data.error} />    
    const apiKey = getStripePublishableKey(data.billingPaymentIntentInfo.shopId);
    return (
      <StripeProvider apiKey={apiKey}>
        <Elements>
          <AuthenticateStripePayment 
            clientSecret={data.billingPaymentIntentInfo.clientSecret} 
            onSuccess={this.handleSuccess.bind(this)}
            onError={this.handleError.bind(this)}
            />
        </Elements>
      </StripeProvider>
    )
  }

  handleSuccess() {
    this.props.requestShowOrderStatus(this.props.accountId, this.props.orderId, "verifying");
  }

  handleError(msg) {
    this.props.requestShowOrderStatus(this.props.accountId, this.props.orderId, "error", msg);    
  }

}

const QUERY = gql`
  query billingPaymentIntentInfo($salesOrderId:ID!) {
    billingPaymentIntentInfo(salesOrderId: $salesOrderId) {
      clientSecret
      shopId
    }
  }
`;

const withQueries = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      salesOrderId: props.orderId
    }    
  })
});

export default connect(null, {requestShowOrderStatus})(withQueries(AuthenticatePayment));